(function(angular){
	'use strict';
	
	var planGoodFitObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			planName: '@'
		},
		controller: [
			'$filter',
			'APP_BASE_PATH',
			'Big',
			'planFactory', 
			PlanGoodFitFunction
		],
		controllerAs: 'planGoodFit'
	};
	
	angular
		.module('viewPlanModule')
		.component('planGoodFit', planGoodFitObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-good-fit.html';
	}
	
	function PlanGoodFitFunction(
		$filter,
		APP_BASE_PATH,
		Big,
		planFactory
	){
		var planGoodFit = this;
		var largestAgeCohort = new Big(0);

		planGoodFit.btnUrl = APP_BASE_PATH + '/select-goal-help';

		planFactory.getPlanDemographics().then(function(response) {

			angular.forEach(response.data[planGoodFit.planName].ageDemographics, function(cohort) {
				var cohortBig = new Big(cohort.value);

				if(largestAgeCohort.lt(cohortBig)) {
					largestAgeCohort = cohortBig;
				}
			});

			angular.forEach(response.data[planGoodFit.planName].ageDemographics, function(cohort) {
				var cohortBig = new Big(cohort.value);

				cohort.relativeValue = cohortBig.div(largestAgeCohort).times(new Big(100));
			});	

			planGoodFit.demo =response.data[planGoodFit.planName];
		});
	}
})(window.angular);